<template>
  <footer>
    <a
      style="margin-left: 8px"
      target="_blank"
      href="http://beian.miit.gov.cn/"
    >
      {{recordShow}}
    </a>
    <br />
  </footer>
</template>
<script>
export default {
  data () {
    return {
      recordShow: '',
    }
  },
  created () {
    this.changeRecord(window.location.hostname);
  },
  methods: {
    changeRecord(url) {
      switch (url) {
        case '':
          this.recordShow = ''
          break
        case '':
          this.recordShow = ''
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/style";
@media screen and (max-width: 999px) {
  footer {
    display: none;
    font-size: px2rem(24);
    color: #b6b7ba;
    text-align: center;
    line-height: 1.8;
    padding: px2rem(32) 0;
    background: #fff;

    a {
      color: #b6b7ba;
      text-decoration: none;
    }
  }
}
footer {
  font-size: 18px;
  color: #0C101B;
  text-align: center;
  line-height: 1.8;
  padding: 16px 0;

  a {
    color: #0C101B;
    text-decoration: none;
  }
}
</style>
